import { useSuspenseQuery } from '@tanstack/react-query';
import { useEmployeeServiceContext } from '../../context/contexts';
import { DataFieldWithDataType } from '../../types';
import { Hasher } from '../hasher';
import { hashString, VersionId } from '../types';
import { EmployeeId } from './types';

export const useEmployeeSearch = (
  searchQuery: string,
  version: VersionId | null
) => {
  const employeeService = useEmployeeServiceContext();
  return useSuspenseQuery({
    queryKey: [
      'employee-search',
      searchQuery,
      version,
      hashString([...employeeService.getDeps()]),
    ],
    queryFn: async () => {
      return searchQuery.length > 1
        ? employeeService.search(searchQuery, version)
        : [];
    },
  });
};

export const useEmployeeProfile = (
  employeeId: EmployeeId,
  version: VersionId,
  fields: DataFieldWithDataType[],
  valueFormatter: (
    field: DataFieldWithDataType,
    value: string | undefined
  ) => string | null
) => {
  const employeeService = useEmployeeServiceContext();
  return useSuspenseQuery({
    queryKey: [
      'employee-profile',
      employeeId,
      version,
      hashString([...employeeService.getDeps(), Hasher.hash(fields)]),
    ],
    queryFn: async () =>
      employeeService.profileData(employeeId, version, fields, valueFormatter),
  });
};
